import { Path, Svg, SvgProps } from 'react-native-svg'

export default function RuFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Path d="M60 0H0V13.3333H60V0Z" fill="#ffffff" />
      <Path d="M60 13.3334H0V26.6667H60V13.3334Z" fill="#0039A6" />
      <Path d="M60 26.6666H0V40H60V26.6666Z" fill="#D52B1E" />
    </Svg>
  )
}
